import { lazy } from 'react'

export const CompanyList = lazy(() => import('./company/CompanyList'))
export const AddCompany = lazy(() => import('./company/AddCompany'))
export const UpdateCompany = lazy(() => import('./company/UpdateCompany'))
export const CompanyUserList = lazy(() => import('./company_user/CompanyUserList'))
export const AddCompanyUser = lazy(() => import('./company_user/AddCompanyUser'))
export const UpdateCompanyUser = lazy(() => import('./company_user/UpdateCompanyUser'))
